import { Component, computed, Inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-deactivate-account-dialog',
  templateUrl: './deactivate-account-dialog.component.html',
  standalone: false,
})
export class DeactivateAccountDialogComponent {
  readonly currentPassword = signal('');
  readonly canDeactivate = computed(
    () => this.currentPassword().trim().length > 0,
  );

  constructor(
    public dialogRef: MatDialogRef<DeactivateAccountDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      accountName: string;
    },
  ) {}

  cancel(): void {
    this.dialogRef.close(null);
  }

  confirm(): void {
    const currentPassword = this.currentPassword().trim();

    if (!currentPassword) {
      return;
    }

    this.dialogRef.close(currentPassword);
  }
}
